function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import * as parser from 'any-date-parser';

/**
 * Parses a date string to Date object.
 * @param {string} dateString
 * Accepts GNU Date input format, e.g. 31-12-2022, 2022-12-31, Dec 31 2022, today, +2 weeks
 * @returns {Date | undefined}
 */

export function parseDateStringToDate(dateString) {
  if (typeof dateString !== 'string') {
    return;
  }
  var date = parser.fromString(dateString);
  if (!date || _typeof(date) !== 'object' || date.invalid) {
    return;
  }
  return date;
}

/**
 * Returns the latest date from an array of given Date objects.
 * @param {Array<Date>} dates - Array of Date objects.
 * @returns {Date | undefined}
 */

export function getLatestDate(dates) {
  if (_typeof(dates) !== 'object' || dates.length === 0) {
    return;
  }
  return dates.reduce(function (date, next) {
    if (!Number.isNaN(Date.parse(date)) && (Number.isNaN(Date.parse(next)) || Date.parse(date) > Date.parse(next))) {
      return date;
    }
    return next;
  });
}

/**
 * Returns the earliest date from an array of given Date objects.
 * @param {Array<Date>} dates - Array of Date objects.
 * @returns {Date | undefined}
 */

export function getEarliestDate(dates) {
  if (_typeof(dates) !== 'object' || dates.length === 0) {
    return;
  }
  return dates.reduce(function (date, next) {
    if (!Number.isNaN(Date.parse(date)) && (Number.isNaN(Date.parse(next)) || Date.parse(date) < Date.parse(next))) {
      return date;
    }
    return next;
  });
}